import * as React from 'react';

import { Zoom } from '../Zoom';

import './index.scss';

interface IProps {
    content: string;
    setSelectedSrc: (src: string) => void;
}

export const SingleMedia: React.FC<IProps> = ({ content, setSelectedSrc }) => (
    <div className="singleMedia">
        <Zoom onClick={() => setSelectedSrc(content)} />
        <img src={content} alt="" />
    </div>
);
